/* eslint-disable react/jsx-no-target-blank */
import React from "react";

import { useAppState } from "hooks/AppContext";
import { formatDateAsAge } from "utils/dates";
import {
    museTrack, getJobTrackingProps, JobTrackingProps, LinkClickedTrackingProps
} from "utils/tracking";
import Tooltip from "@themuse/design-system/lib/components/Tooltip/Tooltip";
import { getLocations } from "utils/strings";
import { CompanyInformationModule } from "./CompanyInformationModule";

import styles from "./JobIndividualHeader.module.scss";

const customLinkClickedTracking = (
    event: React.SyntheticEvent<HTMLAnchorElement, Event>,
    trackingProps: JobTrackingProps & LinkClickedTrackingProps
) => {
    museTrack("Jobs Individual Link Clicked", {
        ...trackingProps,
        ...{
            link: event.currentTarget.href,
        }
    });
};

export const JobIndividualHeader = () => {
    const { job, company } = useAppState();
    const { name: jobName, posted_at: postedDate, locations } = job;
    const { dispLocation, tooltipProps } = getLocations(locations);
    const jobTrackingProps = getJobTrackingProps(job, company);
    const companyNameClickedTrackingProps = {
        ...jobTrackingProps,
        ...{
            click_origin: "company_name",
            new_tab: true
        }
    };

    return (
        <header className={styles.jobHeaderContainer}>
            <a
                href={`/profiles/${company?.short_name}`}
                className={styles.jobHeaderCompanyName}
                onClick={(event: React.SyntheticEvent<HTMLAnchorElement, Event>) => customLinkClickedTracking(event, companyNameClickedTrackingProps)}
                target="_blank"
            >
                { company?.name }
            </a>
            <h1 className={styles.jobHeaderTitle}>{jobName}</h1>
            <div className={styles.jobHeaderSubHeading}>
                { formatDateAsAge(postedDate) }
                <span className={styles.jobHeaderSeparator}>&bull;</span>
                <span className={styles.jobHeaderLocation}>{dispLocation}</span>
                {locations.length > 1 ? <Tooltip {...tooltipProps} /> : null}
            </div>
            <CompanyInformationModule company={company} job={job} displayOnMobile={false} />
        </header>
    );
};
